import { gql } from '@common/hooks';

const RoleLevelsQuery = gql`
  query RoleLevelsQuery {
    roleLevels
  }
`;

export { RoleLevelsQuery };
